import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 pb-1" }, " Вам доступен полный функционал платформы бесплатно в течение 7 дней. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " После — можно подключить только нужные вам функции. Узнайте подробнее и выберите подходящий вариант. ", -1)

import TariffNotificationModal from '@/components/TariffNotificationModal.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TryTrialModal',
  emits: ["hidden", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {

const modal = ref<InstanceType<typeof TariffNotificationModal>>();
__expose({
    show() {
        modal.value?.show();
    },
});

const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modal",
    ref: modal,
    title: "Попробуйте все возможности бесплатно",
    "button-text": "Узнать подробнее",
    "image-url": "/assets/images/tariff/try_all_features.png",
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}
}

})